// client/src/App.js
import React, { useState, useEffect } from 'react';
import Home from './components/Home';
import PhotoActionButtons from './components/PhotoActionButtons';
// Using native camera via file input capture; custom camera removed
import Modal from './components/Modal';
import SimpleModal from './components/SimpleModal';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import ContactForm from './components/ContactForm';
import { useTranslation } from 'react-i18next';
import Terms from './components/Terms';
import LegalNotice from './components/LegalNotice';
import Privacy from './components/Privacy';
import './App.css';

// Error boundary component
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h2>Something went wrong.</h2>
          <p>Error: {this.state.error?.message}</p>
          <button onClick={() => window.location.reload()}>
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

function App() {
  // Removed custom camera state
  const [capturedImage, setCapturedImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false); // NEW: menu state
  const { t } = useTranslation(); // Add translation hook

  // Add error handling for unhandled promise rejections
  useEffect(() => {
    const handleUnhandledRejection = (event) => {
      console.error('Unhandled promise rejection:', event.reason);
      // Prevent the default browser behavior
      event.preventDefault();
    };

    const handleError = (event) => {
      console.error('Global error:', event.error);
    };

    window.addEventListener('unhandledrejection', handleUnhandledRejection);
    window.addEventListener('error', handleError);

    return () => {
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
      window.removeEventListener('error', handleError);
    };
  }, []);

  useEffect(() => {
    const accepted = localStorage.getItem('acceptedTermsAndConditions');
    if (!accepted) {
      setShowTermsModal(true);
    }
  }, []);

  const handleAcceptTerms = () => {
    localStorage.setItem('acceptedTermsAndConditions', 'true');
    setShowTermsModal(false);
  };

  const handlePhotoSelected = (file) => {
    setCapturedImage(file);
    // You can add logic here to pass the image to other components
    // For example, you could use context or props to pass it to Home
    console.log("Foto seleccionada:", file);
  };

  // Removed custom camera close handler

  // This function will be passed to Home component to track modal state
  const handleModalStateChange = (isOpen) => {
    setIsModalOpen(isOpen);
  };

  return (
    <Router>
      <div className="App" style={{ backgroundColor: '#FBF5ED', minHeight: '100vh' }}>
        {/* Navigation */}
        <nav style={{ 
          position: 'fixed',
          top: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 1000,
          width: '100%',
          background: 'rgba(255, 255, 255, 0.50)',
          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.20)',
          borderBottomLeftRadius: '20px',
          borderBottomRightRadius: '20px',
          padding: '12px 16px',
          paddingTop: 'calc(env(safe-area-inset-top, 16px) + 12px)',
          backdropFilter: 'blur(10px)'
        }}>
          <div style={{
            margin: '0 auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}>
            {/* Hamburger Menu */}
            <div style={{ position: 'relative' }}>
            <button
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '8px',
                transition: 'background-color 0.2s ease'
              }}
              onClick={() => setIsMenuOpen((open) => !open)}
              aria-haspopup="true"
              aria-expanded={isMenuOpen}
              onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(0,0,0,0.05)'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
            >
              <svg width="38" height="32" viewBox="0 0 38 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 16H28M10 10H28M10 22H28" stroke="#1E1E1E" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            
            {/* Dropdown Menu */}
            <div
              style={{
                display: isMenuOpen ? 'block' : 'none',
                position: 'absolute',
                top: '110%',
                left: 0,
                background: 'rgba(255, 255, 255, 0.95)',
                backdropFilter: 'blur(10px)',
                minWidth: '200px',
                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.25)',
                zIndex: 1001,
                borderRadius: '8px',
                marginTop: '8px',
                overflow: 'hidden',
                border: '1px solid rgba(0,0,0,0.1)'
              }}
              onMouseLeave={() => setIsMenuOpen(false)}
            >
              <Link 
                to="/" 
                style={{ 
                  display: 'block', 
                  padding: '16px 20px', 
                  textDecoration: 'none', 
                  color: '#212121', 
                  fontFamily: 'SF Pro, sans-serif',
                  fontWeight: '600',
                  fontSize: '16px',
                  borderBottom: '1px solid rgba(0,0,0,0.1)',
                  transition: 'background-color 0.2s ease'
                }} 
                onClick={() => setIsMenuOpen(false)}
                onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255, 210, 117, 0.2)'}
                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
              >
{t('menu.home')}
              </Link>
              <Link 
                to="/terms" 
                style={{ 
                  display: 'block', 
                  padding: '16px 20px', 
                  textDecoration: 'none', 
                  color: '#212121', 
                  fontFamily: 'SF Pro, sans-serif',
                  fontWeight: '600',
                  fontSize: '16px',
                  borderBottom: '1px solid rgba(0,0,0,0.1)',
                  transition: 'background-color 0.2s ease'
                }} 
                onClick={() => setIsMenuOpen(false)}
                onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255, 210, 117, 0.2)'}
                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
              >
{t('menu.terms')}
              </Link>
              <Link 
                to="/contact" 
                style={{ 
                  display: 'block', 
                  padding: '16px 20px', 
                  textDecoration: 'none', 
                  color: '#212121', 
                  fontFamily: 'SF Pro, sans-serif',
                  fontWeight: '600',
                  fontSize: '16px',
                  transition: 'background-color 0.2s ease'
                }} 
                onClick={() => setIsMenuOpen(false)}
                onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255, 210, 117, 0.2)'}
                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
              >
{t('menu.contact')}
              </Link>
            </div>
            </div>

            {/* Selector de idioma eliminado - solo español */}
          </div>
        </nav>
        <Routes>
          <Route path="/" element={
            <>
              <Home
                capturedImage={capturedImage}
                onModalStateChange={handleModalStateChange}
              />
              {!isModalOpen && <PhotoActionButtons onPhotoSelected={handlePhotoSelected} />}
            </>
          } />
          <Route path="/terms" element={<Terms />} />
          <Route path="/legal" element={<LegalNotice />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/contact" element={<ContactForm />} />
        </Routes>
        {showTermsModal && (
          <SimpleModal onClose={handleAcceptTerms}>
            <div style={{ padding: '1.5rem', textAlign: 'center' }}>
              <h2>Términos y Condiciones</h2>
              <p>
                Por favor, lee y acepta nuestros{' '}
                <a href="/terms.html" target="_blank" rel="noopener noreferrer">
                  Términos y Condiciones
                </a>{' '}
                para utilizar este sitio web.
              </p>
              <button onClick={handleAcceptTerms} style={{ marginTop: '1rem', padding: '0.5rem 1.5rem' }}>
                Aceptar
              </button>
            </div>
          </SimpleModal>
        )}
      </div>
    </Router>
  );
}

export default App;
